import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

// Component for routes that require authentication
const ProtectedRoute = ({ 
  requiredRoles = [], 
  redirectPath = '/login' 
}) => {
  const { isAuthenticated, user, loading } = useAuth()
  const location = useLocation()

  // 🛑 Don't evaluate anything until auth is done loading
  if (loading) {
    return <div className="flex justify-center items-center h-screen">🔄 Loading...</div>
  }

  // 🔐 User is not authenticated AFTER loading completes
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />
  }

  // 🔐 User doesn't have the correct role
  if (requiredRoles.length > 0 && !requiredRoles.includes(user?.role)) {
    return <Navigate to="/unauthorized" replace />
  }

  return <Outlet />
}

export default ProtectedRoute
